module.exports = __webpack_public_path__ + "static/media/sent.1fafc4f7.svg";